import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ProfileTopComponent} from './profile-top.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {RouterModule} from '@angular/router';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {IconsModule} from "../icons/icons.module";



@NgModule({
  declarations: [
    ProfileTopComponent,
  ],
  exports: [
    ProfileTopComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    InlineSVGModule,
    BsDropdownModule,
    IconsModule
  ]
})
export class ProfileTopModule { }
